<template>
  <div class="content homepage header-margin">
    <div class="row">
      <div class="columns small-12 small-centered">
        <div class="actionheader">
          <h1>
            <strong>Order your product</strong>
          </h1>
        </div>
        <div class="dark-text">
          <p class="text-center">Fill out the information below, accept the lens program's terms, and click Review Order. Once complete, you will be given instructions on how to send us your frames.</p>
        </div>
      </div>
    </div>
    <div class="row" v-if="errors.any() || cylsignerror || addressError">
      <div class="columns small-12">
        <legend style="color:red;">Please correct the following errors:</legend>
        <p class="smaller-text error" v-if="cylsignerror">LE and RE cyl signs must match (both positive or negative)</p>
        <p class="smaller-text error" v-if="addressError">{{ addressErrorMessage }}</p>
        <p class="smaller-text error" v-for="(e, index) in uniqueErrors(errors.all())" :key="index">{{ e }}</p>
      </div>
    </div>
    <form @submit.prevent="validateBeforeReview">
      <original-about-info v-if="program.programType == 'ECPStandard'" :sampleobject='sampleobject'></original-about-info>
      <university-about-info v-if="program.programType == 'University'" :sampleobject='sampleobject'></university-about-info>
      <employee-about-info v-if="program.programType == 'Employee' || program.programType == 'SalesRep'" :sampleobject='sampleobject' @hasInvalidEmail="updateInvalidEmailAddress"></employee-about-info>
      <about-info v-if="program.programType == 'ECPChoice'" :sampleobject='sampleobject' :program="program"></about-info>

      <ship-info v-if="program.programType == 'ECPStandard' || program.programType == 'ECPChoice' || program.programType == 'SalesRep'" :choices='choices' :sampleobject='sampleobject' @hasDuplicateOrder1="updateDuplicateOrderData1"
       @hasDuplicateOrder2="updateDuplicateOrderData2" @hasDuplicateOrder3="updateDuplicateOrderData3" @hasInvalidGeoInfo="updateGeoLocationInfo" @hasInvalidEmail="updateInvalidEmailAddress" @hasNoSupplier="updateSupplierNotFound" @addressValidationError="handleAddressError"></ship-info>
      <rx-info :sampleobject='sampleobject' :choices='choices'  @hasInvalidNVBValue="updateNVBValue"></rx-info>
      <frame-info :program="program" :sampleobject='sampleobject'></frame-info>

      <div class="row" style="margin-top: 50px">
        <div class="columns small-6 medium-10 text-right 1p">
          <router-link class="btn btn-submit btn-order-lenses" :to="{ name: 'coupon_validator', params: { couponCode: sampleobject.couponCode }}">Go Back</router-link>
        </div>
        <div class="columns small-6 medium-2  text-right 1p">
          <input type="submit" class="btn btn-submit btn-order-lenses" value="Review Order"> </div>
      </div>
    </form>
  </div>
</template>

<script>
import RxInfo from "@/components/order/RxInfo";
import ShipInfo from "@/components/order/ShipInfo";
import FrameInfo from "@/components/order/frame/FrameInfo";
import AboutInfo from "@/components/order/AboutInfo";

import OriginalAboutInfo from "@/components/order/OriginalAboutInfo";
import UniversityAboutInfo from "@/components/order/UniversityAboutInfo";
import EmployeeAboutInfo from "@/components/order/EmployeeAboutInfo";

import Vue from "vue";

export default {
  components: {
    RxInfo,
    ShipInfo,
    FrameInfo,
    AboutInfo,
    OriginalAboutInfo,
    UniversityAboutInfo,
    EmployeeAboutInfo
  },
  data() {
    return {
      sampleobject: null,
      choices: null,
      program: null,
      termsContent: "",
      hasDuplicateOrder1: false,
      hasDuplicateOrder2: false,
      hasDuplicateOrder3: false,
      hasInvalidGeoInfo: false,
      hasInvalidNVBValue: false,
      hasInvalidEmail: false,
      hasNoSupplier: false,
      isTGenS: false,
      addressError: false,
      addressErrorMessage: "Address validation failed. Please check your shipping information.",
    };
  },
  computed: {
    cylsignerror() {
      if (
        this.sampleobject.recyl &&
        this.sampleobject.lecyl &&
        this.sampleobject.recyl.length > 0 &&
        this.sampleobject.lecyl.length > 0
      ) {
      if (this.sampleobject.lecyl[0] == '0' || this.sampleobject.recyl[0] == '0') // If first index is 0
        return false;

        return this.sampleobject.lecyl[0] != this.sampleobject.recyl[0];
      }
      return false;
    }
  },
  methods: {
    handleError() {
      this.$router.replace("/error/");
    },
    updateDuplicateOrderData1(value) {
      this.hasDuplicateOrder1 = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' })
    },
    updateDuplicateOrderData2(value) {
      this.hasDuplicateOrder2 = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' })
    },
    updateDuplicateOrderData3(value) {
      this.hasDuplicateOrder3 = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' })
    },
    updateGeoLocationInfo(value) {
      this.hasInvalidGeoInfo = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' })
    },
    updateNVBValue(value) {
      this.hasInvalidNVBValue = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' });
    },
    updateInvalidEmailAddress(value) {
      this.hasInvalidEmail = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' })
    },
    updateSupplierNotFound(value) {
      this.hasNoSupplier = value;
      if (!!value)
        window.scrollTo({ top: 800, behavior: 'smooth' })
    },
    handleAddressError(value) {
      this.addressError = value;
      if (value) {
        window.scrollTo({ top: 200, behavior: "smooth" });
      }
    },
    validateBeforeReview() {
      const allErrors = this.$validator.errors.all();
      this.validateBaseCurve(allErrors);
      this.$validator.validateAll().then(result => {
        if (!result) {
          window.scroll(0, 0);
          return;
        }
        if (this.cylsignerror || this.addressError) {
          window.scroll(0, 0);
          return;
        }

        if (this.isTGenS  && this.hasDuplicateOrder1 || this.hasDuplicateOrder2 || this.hasDuplicateOrder3 || 
            this.hasInvalidGeoInfo || this.hasInvalidNVBValue || this.hasInvalidEmail || this.hasNoSupplier) {
          window.scrollTo({ top: 200,})
          return;
        }

        if (this.hasDuplicateOrder1 || this.hasDuplicateOrder2 || this.hasDuplicateOrder3 || 
            this.hasInvalidGeoInfo || this.hasInvalidNVBValue || this.hasInvalidEmail || this.hasNoSupplier) {
          window.scrollTo({ top: 800,})
          return;
        }

        // eslint-disable-next-line
        this.$router.push({
          name: "order_review",
          params: {
            sampleobject: this.sampleobject,
            choices: this.choices,
            program: this.program
          }
        });
      });
    },
    uniqueErrors(errors) {
      const seen = new Set();
      const result = [];
      const pantoRequiredDesigns = ['VXXRTRACK', 'VXPHYEXTTRACK'];

      if (!pantoRequiredDesigns.includes(this.sampleobject.design)) {
        errors = errors.filter(error => !/Panto/i.test(error));
      }

      this.validatePanto(errors);
      this.validatePantoAngle();

      for (let error of errors) {
        if (error.includes("PantoA") || error.includes("PantoB")) {
          error = error.replace(/\bPanto[AB]\b/g, "Panto");
          if (seen.has("Panto")) continue; // Only allow one "Panto" message
          seen.add("Panto");
        }

        if (!seen.has(error)) {
          seen.add(error);
          result.push(error);
        }
        
      }
      return result;
    },
    
    validateBaseCurve(errors) {
      const baseCurveRequiredDesigns = [
        'STYLISTICW',
        'SVWRAPSP'
      ];

      if (!baseCurveRequiredDesigns.includes(this.sampleobject.design)) {
        return;
      }

      const value = this.sampleobject.SPBaseCurve;
      const missing = value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
      const alreadyHas = errors.some(error => /Base\s*Curve|BaseCurve/i.test(error));

      if (missing && !alreadyHas) {
        this.$validator.errors.add({
          field: 'BaseCurve',
          msg: 'Base Curve is required'
        });
        errors.push('Base Curve is required');
      }
    },
    validatePanto(errors) {
      const pantoRequiredDesigns = [
        'VXXRTRACK',
        'VXPHYEXTTRACK'
      ];

      if (!pantoRequiredDesigns.includes(this.sampleobject.design)) {
        return;
      }

      const value = this.sampleobject.PantoAngle;
      const missing = value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
      const alreadyHas = errors.some(error => /Panto/i.test(error));

      if (missing && !alreadyHas) {
        this.$validator.errors.add({
          field: 'Panto',
          msg: 'Panto is required'
        });
      }
    },
    validatePantoAngle() {
      const min = -5;
      const max = 25;
      const pantoAngle = this.sampleobject.PantoAngle ? Number(this.sampleobject.PantoAngle) : null;

      if (pantoAngle === null || isNaN(pantoAngle)) {
          return;
      }

      if (pantoAngle < min || pantoAngle > max) {
        ['PantoA', 'PantoB', 'PantoC', 'PantoAngle'].forEach(field => { this.$validator.errors.remove(field);});
      }
    }
  },
  created() {
    this.sampleobject = this.$parent.sampleobject;
    this.choices = this.$parent.choices;
    this.program = this.$parent.program;
    var preCouponText = this.$route.params.couponCode.toString().split('-')[0];
    this.isTGenS = preCouponText.includes("TGSIX");
  },
  // Add `programType` as a prop in the component options:
  props: {
    programType: {
      type: String,
    }
  },
};
</script>

<style>
.dark-text {
  font-size: 14px;
  margin-top: 25px;
  line-height: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 500px;
}

.dark-text p {
  color: #050505 !important;
  line-height: 20px;
}

.actionheader h1 {
  text-align: center;
  color: #0b4279 !important;
  font-size: 36pt;
  margin-top: 50px;
}

.review-order-button {
  width: 100%;
  color: #fff;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
